export default {"src":"/_next/static/media/logo-CCA-transparent-mobile.99263c93.svg","height":34,"width":124,"blurWidth":0,"blurHeight":0};